exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bar.person{background:#fff;border:1px solid #d2d2d2;cursor:pointer;position:relative}.bar.person i{color:#000;position:absolute;top:2px;left:8px}.bar.person h4{padding-left:30px;display:inline-block;font-weight:600!important;margin-top:0;margin-bottom:0;font-size:14px;line-height:32px;color:#0c2d39;font-weight:400;margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a216e63","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Common/Person.vue
// module id = 408
// module chunks = 0